import axios from 'axios';

// Create axios instance with base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

let tokenUpdateCallback: ((token: string | null) => void) | null = null;

export const setTokenUpdateCallback = (callback: (token: string | null) => void) => {
  tokenUpdateCallback = callback;
};

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    // Get token directly from localStorage for maximum reliability
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Request: Adding auth token to request');
    } else {
      console.log('Request: No auth token available');
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    
    // Handle authentication errors
    if (error.response?.status === 401) {
      console.log('401 Unauthorized response received');
      
      // Clear token from localStorage
      localStorage.removeItem('token');
      
      // Notify token update through callback
      if (tokenUpdateCallback) {
        tokenUpdateCallback(null);
      }
      
      // Only redirect if not already on login page
      const currentPath = window.location.pathname;
      if (!currentPath.includes('/login')) {
        console.log('Redirecting to login page');
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default api; 